export function getTargetViewName(event) {
  return (event?.detail?.target ?? event?.target)?.getAttribute('view-name');
}
